// extracted by mini-css-extract-plugin
export default {"MyProfile":"my-profile_MyProfile__3+v3j","cardContent":"my-profile_cardContent__MGcjf"};